var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('mzj_Main',{attrs:{"list":_vm.list}}),_c('mzj_LIstVue',{attrs:{"myList":_vm.myList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }